import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import PreloadButton from '../../interface/PreloadButton';
import SuccessModal from '../../components/RequestForms/SuccessModal';

const ServiceForm = observer(() => {
    const { ServiceStore: store, ProductStore } = useStores();
    const [values, setValues] = useState({
        contract: '',
        categoryId: '',
        branch: '',
        carNumber: '',
        comment: '',
    });

    const resetForm = () => {
        setValues({
            contract: '',
            categoryId: 'null',
            branch: 'null',
            carNumber: '',
            comment: '',
        });
    };

    // Effects
    useEffect(() => {
        store.getBranches();
        ProductStore.getCategories();

        return () => {
            store.resetStore();
            resetForm();
        };
    }, [ProductStore, store]);

    // Handlers
    const handleChange = e => {
        setValues({
            ...values,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = e => {
        e.preventDefault();

        store.send(values, resetForm);
    };

    // Render
    return (
        <>
            <div className="default-title-block mb-25">Подать заявку на сервисное обслуживание</div>
            <form className="tech-form mb-60" onSubmit={handleSubmit}>
                <div className="tech-form__wrap-elements">
                    <div className="tech-form__wrap-input tech-form__wrap-input--w50">
                        <label className="tech-form__label">Тип машины / оборудования</label>
                        <select className="tech-form__select" value={values.categoryId} name="categoryId" onChange={handleChange} required>
                            <option value="">Выберите</option>
                            {ProductStore.categories.map(category => (
                                <option key={category?.id} value={category?.id}>
                                    {category?.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="tech-form__wrap-input tech-form__wrap-input--w50">
                        <label className="tech-form__label">Заводской номер машины</label>
                        <input
                            className="tech-form__input"
                            type="text"
                            value={values.carNumber}
                            name="carNumber"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="tech-form__wrap-input tech-form__wrap-input--w50">
                        <label className="tech-form__label">Номер договора поставки/оказания услуг</label>
                        <input
                            className="tech-form__input"
                            type="text"
                            value={values.contract}
                            name="contract"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="tech-form__wrap-input tech-form__wrap-input--w50">
                        <label className="tech-form__label">Ближайший к вам город/страна</label>
                        <select className="tech-form__select" value={values.branch} name="branch" onChange={handleChange} required>
                            <option value="">Выберите</option>
                            {store.branches.map(branch => (
                                <option key={branch?.id} value={branch?.id} disabled={branch?.id === 0}>
                                    {branch.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="tech-form__wrap-input">
                        <label className="tech-form__label">Причина поломки</label>
                        <textarea
                            className="tech-form__input tech-form__input--textarea"
                            value={values.comment}
                            name="comment"
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <div className="tech-form__wrap-btn">
                        <PreloadButton isLoad={store.loading} className="tech-form__btn">
                            Подать заявку
                        </PreloadButton>
                    </div>
                </div>
            </form>

            <SuccessModal open={store.success} />
        </>
    );
});

export default ServiceForm;
